exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._remove_limit_bg{background-image:url(" + require("images/register_bg.jpg") + ")}._remove_limit_header{width:100%;border-bottom:1px solid #dedede;background-color:#fff}._remove_limit_header_container{clear:both;width:1200px;height:68px;margin:0 auto;position:relative}._remove_limit_header_container>img{display:inline-block;height:58px;margin-top:5px}._remove_limit_header_container>b{display:inline-block;font-size:1.4rem;margin-left:10px;padding-left:10px;color:#333;font-weight:400;border-left:1px solid #333;position:relative;top:-22px}._remove_limit_header_container>a{display:inline-block;font-size:1.4rem;color:#333;text-decoration:underline;position:absolute;top:26px;right:0}.remove_limit_frame{width:30%;margin:0 auto;background-color:#fff;box-shadow:0 0 10px 0 #ddd;position:relative}._retrieve_form_container{width:80%;margin:0 auto;padding:20px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-caf56c1e","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/sign/RemoveLimit.vue
// module id = 572
// module chunks = 24